/** Wait after mount before firing requests (Vida tabs). */
export const TAB_MOUNT_DELAY_MS = 1000;

/** Minimum time the loading overlay stays visible when opening a tab (includes delay + requests). */
export const TAB_MIN_VISIBLE_LOADING_MS = 2000;

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * After the tab mounts: waits {@link TAB_MOUNT_DELAY_MS}, runs `work` (requests),
 * then ensures total elapsed time from the start is at least {@link TAB_MIN_VISIBLE_LOADING_MS}.
 */
export async function runTabMountSequence(work: () => Promise<void>): Promise<void> {
  const started = Date.now();
  await sleep(TAB_MOUNT_DELAY_MS);
  await work();
  const elapsed = Date.now() - started;
  if (elapsed < TAB_MIN_VISIBLE_LOADING_MS) {
    await sleep(TAB_MIN_VISIBLE_LOADING_MS - elapsed);
  }
}
